<template>
  <div>
    <div style="margin-bottom: 10px;">
      <sj-button @click="isActive = !isActive">
        {{ isActive ? "隐藏折叠" : "显示折叠" }}
      </sj-button>
      <SjCollapse :value="isActive">
        <sj-card style="height: 200px;">
          <div style="padding: 10px;">折叠的部分</div>
        </sj-card>
      </SjCollapse>
    </div>
    <div style="margin-bottom: 10px;">
      <sj-button @click="isActive2 = !isActive2">
        快速折叠
      </sj-button>
      <SjCollapse :value="isActive2" :duration="0.1">
        <sj-card style="height: 200px;">
          <div style="padding: 10px;">折叠的部分</div>
        </sj-card>
      </SjCollapse>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      isActive2: false
    };
  }
};
</script>

<style scoped lang="less"></style>
